import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ChevronRight, Rocket } from 'lucide-react';

export const OnboardingSteps = ({ counts }) => {
  const navigate = useNavigate();
  const steps = [
    { key: 'employee', label: 'Personel ekle', desc: 'Sahada çalışacak personellerinizi sisteme ekleyin', done: counts.employees > 0, to: '/employees' },
    { key: 'docs', label: 'Personel belgelerini yükle', desc: 'Personellerinizin İSG belgelerini yükleyin', done: counts.hasDocs, to: '/employees' },
    { key: 'permit', label: 'Çalışma izni talebi oluştur', desc: 'İlk çalışma izni talebinizi İSG birimine gönderin', done: counts.permits > 0, to: '/work-permits/new' },
  ];
  const doneCount = steps.filter(s => s.done).length;
  if (doneCount === steps.length) return null;

  return (
    <div className="rounded-xl border border-emerald-200 bg-white p-5 space-y-4" data-testid="firm-onboarding">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Rocket className="h-5 w-5 text-emerald-600" />
          <h2 className="font-semibold text-slate-900">Başlangıç Adımları</h2>
        </div>
        <span className="text-xs font-medium text-slate-500" data-testid="firm-onboarding-progress">{doneCount}/{steps.length} tamamlandı</span>
      </div>
      <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${(doneCount / steps.length) * 100}%` }} />
      </div>
      <ol className="space-y-2">
        {steps.map((s, i) => (
          <li key={s.key}>
            <button
              type="button"
              onClick={() => navigate(s.to)}
              className={`w-full flex items-center gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors ${s.done ? 'border-emerald-100 bg-emerald-50/50' : 'hover:bg-slate-50'}`}
              data-testid={`firm-onboarding-step-${s.key}`}
              data-done={s.done}
            >
              {s.done
                ? <CheckCircle2 className="h-6 w-6 text-emerald-600 shrink-0" />
                : <span className="h-6 w-6 shrink-0 rounded-full border-2 border-slate-300 text-xs font-semibold text-slate-500 flex items-center justify-center">{i + 1}</span>}
              <span className="flex-1 min-w-0">
                <span className={`block text-sm font-medium ${s.done ? 'text-emerald-800 line-through decoration-emerald-300' : 'text-slate-800'}`}>{s.label}</span>
                <span className="block text-xs text-slate-500">{s.desc}</span>
              </span>
              {!s.done && <ChevronRight className="h-4 w-4 text-slate-400" />}
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
};
